import { render, staticRenderFns } from "./information.vue?vue&type=template&id=37bbb6fd&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"
import style0 from "./information.vue?vue&type=style&index=0&id=37bbb6fd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bbb6fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37bbb6fd')) {
      api.createRecord('37bbb6fd', component.options)
    } else {
      api.reload('37bbb6fd', component.options)
    }
    module.hot.accept("./information.vue?vue&type=template&id=37bbb6fd&scoped=true", function () {
      api.rerender('37bbb6fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/mobilePreview/components/information.vue"
export default component.exports